export default __webpack_public_path__ + "static/media/BrixSansRegular.e20ae833.woff2";